import axios from 'axios'
import qs from 'qs'
import { MessageBox } from 'element-ui'
import { router } from '../main.js'
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';

//axios.defaults.baseURL = '/api';  //开发环境
axios.defaults.baseURL = '/';  //线上环境

export function ajax(url, params, method) {
    return new Promise((resolve, reject) => {
    	if (method && method == 'get') {
    		axios.get(url, qs.stringify(params)).then(response => {  
                if (response.data.code == -2) {  //session失效
                    MessageBox.alert('会话已过期，3秒后将自动跳转到开发者中心', '会话已过期', {
                        type: 'warning',
                        showClose: false,
                        callback: action => {
                            window.location.href = 'https://developer.lm.virbox.com';
                        }
                    });
                    setTimeout(() => {
                        MessageBox.close();
                        window.location.href = 'https://developer.lm.virbox.com';
                    }, 3000);
                } else {
                    resolve(response.data); 
                };      	          	                
	        }).catch((error) => {
	            reject(error);
	        })
    	} else {
    		axios.post(url, qs.stringify(params)).then(response => {        	
            	if (response.data.code == -2) {  //session失效
                    MessageBox.alert('会话已过期，3秒后将自动跳转到开发者中心', '会话已过期', {
                        type: 'warning',
                        showClose: false,
                        callback: action => {
                            window.location.href = 'https://developer.lm.virbox.com';
                        }
                    });
                    setTimeout(() => {
                        MessageBox.close();
                        window.location.href = 'https://developer.lm.virbox.com';
                    }, 3000);
                } else {
                    resolve(response.data); 
                };                
	        }).catch((error) => {
	            reject(error);
	        })
    	};
    })
};


// WEBPACK FOOTER //
// ./src/api/api.js